import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TextContentService } from '@core/text-content/text-content.service';
import { FlightTrackerCopy } from '@dynamic-components/flight-tracker/types/flight-tracker-copy.type';
import { Observable } from 'rxjs';

import { FlightTrackerLeg } from '../../../types/flight-tracker-leg.type';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker-results-origin-column',
  templateUrl: './flight-tracker-results-origin-column.component.html',
  styleUrls: ['./flight-tracker-results-origin-column.component.scss'],
})
export class FlightTrackerResultsOriginColumnComponent implements OnInit {
  private _destroy = inject(DestroyRef);

  leg;

  @Input('flightTrackerLeg') flightTrackerLeg: FlightTrackerLeg;

  flightTrackerText$: Observable<FlightTrackerCopy>;

  constructor(private textContentService: TextContentService) {}

  ngOnInit() {
    this.flightTrackerText$ = this.textContentService
      .getJsonAsset('flight-tracker')
      .pipe(takeUntilDestroyed(this._destroy));

    this.leg = this.flightTrackerLeg;
    this.leg.originTerminal = !this.leg.originTerminal
      ? '-'
      : this.leg.originTerminal;
    this.leg.originGate = !this.leg.originGate ? '-' : this.leg.originGate;
  }
}
